// extracted by mini-css-extract-plugin
export default {"divSeparator":"styles_divSeparator__oDryQ","tagSection":"styles_tagSection__Io2IW"};